import React, { useCallback } from "react";
import { Add } from "ceicons";
import { useDropzone } from "react-dropzone";
import { Image } from "semantic-ui-react";
import "./imageDropzone.scss";
import { toast } from "react-toastify";
import { useTranslation } from "ceco-polyglot";

export default function ImageDropzone({
  file,
  setFile,
  fileError,
  setFileError,
  imgLoaded,
  circular,
  color
}) {
  const t = useTranslation();

  // const [file, setFile] = useState();
  // const [fileError, setFileError] = useState();
  const onDrop = useCallback(
    (droppedFile) => {
      if (droppedFile.length > 0) {
        let reader = new FileReader();

        reader.onloadend = () => {
          setFile({
            file: droppedFile,
            imagePreviewUrl: reader.result,
          });
        };
        reader.readAsDataURL(droppedFile[0]);
      } else {
        toast.error(t("warning.maxSizeImage"));
      }
    },
    [setFile, t]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    noKeyboard: true,
    multiple: false,
    onDrop,
    maxSize: 30000000,
  });
  return (
    <div className="upload-template" {...getRootProps()} style={{ backgroundColor: color}}>
      <input {...getInputProps()} />

      {!imgLoaded && !file && <Add />}

      {file && (
        <Image
          className="file-upload"
          src={file.imagePreviewUrl}
          circular={circular}
        />
      )}
      {imgLoaded && !file && (
        <Image className="imgLoaded" src={imgLoaded} avatar />
      )}
      {fileError && <p className="file-error">Fichero no valido</p>}
    </div>
  );
}
